import React, { useState } from 'react';
import { updateClient } from '../utils/storage';

const ClientTasksSection = ({ client, onClose }) => {
  const [currentClient, setCurrentClient] = useState(client);

  // Recopilar todas las tareas de todas las reuniones del cliente
  const allTasks = currentClient.meetings.reduce((acc, meeting) => {
    if (meeting.tasks && Array.isArray(meeting.tasks)) {
      const tasksWithMeetingInfo = meeting.tasks.map(task => ({
        ...task,
        meetingDate: meeting.date,
        meetingType: meeting.meetingType,
        meetingId: meeting.id,
        clientId: currentClient.id // Añadir ID del cliente para facilitar la actualización
      }));
      return [...acc, ...tasksWithMeetingInfo];
    }
    return acc;
  }, []);

  // Ordenar tareas por fecha límite (si existe) o por fecha de la junta
  allTasks.sort((a, b) => {
    const dateA = a.dueDate ? new Date(a.dueDate) : new Date(a.meetingDate);
    const dateB = b.dueDate ? new Date(b.dueDate) : new Date(b.meetingDate);
    return dateA - dateB;
  });

  const handleTaskCompletion = async (taskId, meetingId, isCompleted, comment) => {
    try {
      const updatedClient = {
        ...currentClient,
        meetings: currentClient.meetings.map(m => {
          if (m.id === meetingId) {
            return {
              ...m,
              tasks: m.tasks.map(task => 
                task.id === taskId ? { ...task, completed: isCompleted, completionComment: comment } : task
              )
            };
          }
          return m;
        })
      };

      await updateClient(currentClient.id, updatedClient);
      setCurrentClient(updatedClient);
    } catch (error) {
      console.error('Error al actualizar tarea:', error);
      alert('Error al actualizar tarea. Por favor, intente de nuevo.');
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-3xl w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <div className="flex justify-between items-start mb-4">
            <h2 className="text-xl font-bold text-[#0061A8]">Tareas del Cliente: {currentClient.name}</h2>
            <button 
              onClick={onClose}
              className="text-[#63666A] hover:text-[#0061A8]"
            >
              ✕
            </button>
          </div>

          {allTasks.length === 0 ? (
            <p className="text-[#63666A] text-sm">No hay tareas registradas para este cliente.</p>
          ) : (
            <div className="space-y-4">
              {allTasks.map((task, index) => (
                <div 
                  key={task.id || index} // Usar task.id si existe, sino index
                  className={`bg-[#D1D3D4] p-3 rounded-md ${task.completed ? 'opacity-70 border-l-4 border-green-500' : 'border-l-4 border-yellow-500'}`}
                >
                  <div className="flex items-center justify-between">
                    <p className={`text-sm font-medium ${task.completed ? 'line-through text-[#63666A]' : 'text-[#0061A8]'}`}>
                      {task.description}
                    </p>
                    <input
                      type="checkbox"
                      checked={task.completed || false}
                      onChange={(e) => handleTaskCompletion(task.id, task.meetingId, e.target.checked, task.completionComment || '')}
                      className="form-checkbox h-5 w-5 text-green-600"
                    />
                  </div>
                  <p className="text-xs text-[#63666A] mt-1">
                    Asignado a: {task.assignedTo || 'N/A'}
                  </p>
                  <p className="text-xs text-[#63666A]">
                    Fecha Límite: {task.dueDate ? new Date(task.dueDate).toLocaleDateString('es-MX') : 'N/A'}
                  </p>
                  <p className="text-xs text-[#63666A]">
                    Origen: Junta del {new Date(task.meetingDate).toLocaleDateString('es-MX')} ({task.meetingType || 'N/A'})
                  </p>
                  {task.completed && (
                    <div className="mt-2">
                      <label className="block text-xs font-medium text-[#63666A]">Comentario de finalización:</label>
                      <textarea
                        value={task.completionComment || ''}
                        onChange={(e) => handleTaskCompletion(task.id, task.meetingId, task.completed, e.target.value)}
                        rows="1"
                        className="mt-1 block w-full border border-[#63666A] rounded-md shadow-sm py-1 px-2 text-xs text-[#0061A8] focus:outline-none focus:ring-[#0061A8] focus:border-[#0061A8]"
                        placeholder="Comentario..."
                      ></textarea>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ClientTasksSection;
